import { getClientConfig } from './helpers'
import fetch from 'isomorphic-unfetch'

export const getHeadersForApiCall = () => {
  const token = localStorage.getItem('idToken')
  return {
    Authorization: `Bearer ${token}`,
  }
}

export const track = data => {
  const { TRACK_API_URL } = getClientConfig()
  console.log(JSON.stringify(data))
  return fetch(TRACK_API_URL, {
    method: 'POST',
    headers: getHeadersForApiCall(),
    body: JSON.stringify(data),
  })
}
